import { isTypeSimpleColumn, TypeSimpleColumnSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulSimpleColumn = ({
  entry,
}: {
  entry: Entry<TypeSimpleColumnSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeSimpleColumn(entry)) {
    return null;
  }

  return (
    <div className='flex flex-col text-center mb-4 sm:mx-4'>
      <h2 className='my-3 font-header font-semibold sm:text-xl sm:leading-6 text-gray-500'>
        {entry.fields.title}
      </h2>
      <p className='leading-5.5'>{entry.fields.description}</p>
    </div>
  );
};

export default ContentfulSimpleColumn;
